import { useContext } from 'react';
import { IntegrationAppProvidersContext } from 'src/contexts/IntegrationAppProvidersContext';

export function useIntegrationAppProviders() {
  const ctx = useContext(IntegrationAppProvidersContext);
  if (!ctx)
    throw new Error(
      'useIntegrationProviders must be used within IntegrationProvidersProvider',
    );
  return ctx;
}
